import { render, staticRenderFns } from "./NoteCreate.vue?vue&type=template&id=72ee5f68&"
import script from "./NoteCreate.vue?vue&type=script&lang=js&"
export * from "./NoteCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports